import React from 'react';

import Testimonial, { TestimonialProps } from './Testimonial';

const TESTIMONIAL_DATA: TestimonialProps[] = [
  {
    name: 'Vinod Khosla',
    title: 'Founder, Khosla Ventures',
    quote:
      'The Information is one of the few trusted sources of tech news that I reference on a daily basis.”',
    img: 'vinod_khosla.png',
  },
  {
    name: 'Julia Hartz',
    title: 'CEO, Eventbrite',
    quote: 'I subscribe to The Information because it is the highest quality news in tech today.”',
    img: 'julia_hartz.png',
  },
];

interface TestimonialsProps {
  className?: string;
}

const Testimonials = ({ className }: TestimonialsProps) => {
  return (
    <div className={className}>
      <div className="mb-24 flex w-full items-end border-0 border-b-[5px] border-solid border-primary-magenta sm:mb-32 sm:items-center" />
      <aside>
        <h3 className="my-0 font-suisse-intl-mono text-overline-md text-primary-magenta">
          Our subscribers say
        </h3>
        <div className="mt-32 flex flex-col items-center gap-48 sm:flex-row sm:items-baseline sm:gap-[69px] md:justify-between md:gap-[59px] lg:gap-[159px]">
          {TESTIMONIAL_DATA.map((testimonial) => (
            <Testimonial
              key={testimonial.name}
              name={testimonial.name}
              title={testimonial.title}
              quote={testimonial.quote}
              img={testimonial.img}
            />
          ))}
        </div>
      </aside>
    </div>
  );
};

export default Testimonials;
